import { Component, OnInit } from '@angular/core';
import { footerInfoDto } from '../../../../../../projects/tekkeys-common/src/lib/DTO/footer-info.dto';
import { AppConfigs } from "../../../../../generalVariabl";
import { ThemeService } from 'shared/services/parameter/theme.service';
import { ParameterModel } from 'shared/services/parameter/parameter.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer-links',
  templateUrl: './footer-links.component.html',
  styleUrls: ['./footer-links.component.scss'],
})
export class FooterLinksComponent implements OnInit {
  contactInformation: footerInfoDto[];
  localisation: string;
  content = AppConfigs.Footer;

  parameter$: Observable<ParameterModel>;

  constructor(private themeService: ThemeService) {}

  ngOnInit() {
    this.parameter$ = this.themeService.parameter$;
  }
}
